// extracted by mini-css-extract-plugin
export default {"container":"GridHeader_container__rIKJ0","search":"GridHeader_search__vHO4+"};